/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useEffect, useRef, useState } from "react";
import HoverText from "./HoverText";
import { useGLTF, Billboard, Text } from "@react-three/drei";
const data = {
  position: [-15, 23, 0],
  islandName: "Projects",
};

export default function Model({ ...props }) {
  const group = useRef();
  const [visible, setVisible] = useState(false);

  const { nodes, materials } = useGLTF("../../../ProjectIsland.glb");

  return (
    <>
      <HoverText visible={visible} fontProps={props.fontProps} data={data} />
      <group
        ref={group}
        {...props}
        dispose={null}
        onPointerEnter={() => {
          props.hoverIslandEnter("ProjectIsland");
          setVisible(true);
        }}
        onPointerLeave={() => {
          props.hoverIslandExit("ProjectIsland");
          setVisible(false);
        }}
        onClick={() => props.setOpen1(true)}
      >
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-grindstone_side"].geometry}
          material={materials["minecraft_block-grindstone_side"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-daylight_detector_top"].geometry}
          material={materials["minecraft_block-daylight_detector_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-stone"].geometry}
          material={materials["minecraft_block-stone"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-stripped_birch_log"].geometry}
          material={materials["minecraft_block-stripped_birch_log"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-crafting_table_front"].geometry}
          material={materials["minecraft_block-crafting_table_front"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-chain"].geometry}
          material={materials["minecraft_block-chain"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-sandstone"].geometry}
          material={materials["minecraft_block-sandstone"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-barrel_top"].geometry}
          material={materials["minecraft_block-barrel_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-barrel_side"].geometry}
          material={materials["minecraft_block-barrel_side"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-redstone_lamp_on"].geometry}
          material={materials["minecraft_block-redstone_lamp_on"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-birch_planks"].geometry}
          material={materials["minecraft_block-birch_planks"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-crafting_table_top"].geometry}
          material={materials["minecraft_block-crafting_table_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-raw_gold_block"].geometry}
          material={materials["minecraft_block-raw_gold_block"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-birch_trapdoor"].geometry}
          material={materials["minecraft_block-birch_trapdoor"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-grindstone_round"].geometry}
          material={materials["minecraft_block-grindstone_round"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-polished_andesite"].geometry}
          material={materials["minecraft_block-polished_andesite"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-dark_oak_log"].geometry}
          material={materials["minecraft_block-dark_oak_log"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-daylight_detector_side"].geometry}
          material={materials["minecraft_block-daylight_detector_side"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-spruce_trapdoor"].geometry}
          material={materials["minecraft_block-spruce_trapdoor"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-piston_top"].geometry}
          material={materials["minecraft_block-piston_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-piston_side"].geometry}
          material={materials["minecraft_block-piston_side"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-redstone_block"].geometry}
          material={materials["minecraft_block-redstone_block"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-crafting_table_side"].geometry}
          material={materials["minecraft_block-crafting_table_side"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-grindstone_pivot"].geometry}
          material={materials["minecraft_block-grindstone_pivot"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_entity-chest-normal"].geometry}
          material={materials["minecraft_entity-chest-normal"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-sandstone_top"].geometry}
          material={materials["minecraft_block-sandstone_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-piston_inner"].geometry}
          material={materials["minecraft_block-piston_inner"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          geometry={nodes["minecraft_block-sand"].geometry}
          material={materials["minecraft_block-sand"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          geometry={nodes["minecraft_block-stone_bricks"].geometry}
          material={materials["minecraft_block-stone_bricks"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          geometry={nodes["minecraft_block-glowstone"].geometry}
          material={materials["minecraft_block-glowstone"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-barrel_bottom"].geometry}
          material={materials["minecraft_block-barrel_bottom"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          geometry={nodes["minecraft_block-sandstone_bottom"].geometry}
          material={materials["minecraft_block-sandstone_bottom"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-spruce_planks"].geometry}
          material={materials["minecraft_block-spruce_planks"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.stone_bricks002.geometry}
          material={materials.stone_bricks_north}
          position={[-9, 11.49, -2.75]}
          rotation={[0, Math.PI / 2, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.stone_bricks003.geometry}
          material={materials.stone_bricks_north}
          position={[-9, 11.49, 1.25]}
          rotation={[0, Math.PI / 2, 0]}
        />
      </group>
    </>
  );
}

useGLTF.preload("../../../ProjectIsland.glb");
